import { Grid, Typography } from '@material-ui/core'
import { ReduxFormField } from '../../../../components/FormInput/ReduxWrappers'
import i18n from '../../../../translations/i18n'
import { MuiClasses } from '../../../../types'
import {
  isInvalidCharacters,
  required
} from '../../../../utils/validation/forms'
import { MyTextArea } from '../../../NewApplication/Fields'

const AdditionalInfoFields = ({
  t,
  isDisabled,
  currentStep,
  classes
}: {
  t: i18n.TFunction
  currentStep: any
  isDisabled: boolean
  classes: MuiClasses
}) => (
  <Grid container>
    <Grid container className={classes.containerItem}>
      <Grid item xs={12} sm={12}>
        <Typography variant='body1' gutterBottom>
          {t('apartment.list.information.additionalInformation')}
        </Typography>
        <ReduxFormField
          name='notes'
          multiline={true}
          disabled={isDisabled}
          component={MyTextArea}
          style={{
            width: '100%',
            height: '320px',
            padding: '20px',
            background: '#E7ECEF'
          }}
          placeholder={t(
            'apartment.list.information.additionalInformationPlaceholder'
          )}
          validate={[required, isInvalidCharacters]}
          required
        />
      </Grid>
    </Grid>
  </Grid>
)

export default AdditionalInfoFields
